Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedValue = void 0;
exports.getLocalizedValue = (locale, value) => {
    if (typeof value === 'object' && locale in value) {
        return value[locale];
    }
    else {
        return value;
    }
};
//# sourceMappingURL=get-localized-value.js.map